const API_ROUTES = {
  REFRESH_TOKEN: `/user-management/v1/refresh/authtoken`,
  LOGIN: `/user-management/v1/login/password`,
  NON_LOGIN: `/user-management/v1/generate/nonLogin`,
  DIAIKIN_LOGIN: `/user-management/v1/login/daikincity`,
  LOGOUT: `/user-management/v1/logout`,
  FORGOT_PASSWORD: ({ userName }) =>
    `/user-management/v1/reset/password/${userName}`,
  RESET_PASSWORD: `/user-management/v1/save/password`,
  CHANGE_PASSWORD: `/user-management/v1/password`,
  ADD_NEW_USER: `user-management/v1/add/newuser`,
  UPDATE_USER: `user-management/v1/userprofile`,
  UPDATE_USER_CONTENT: `user-management/v1/user/content`,
  ADD_BUILDING: `user-management/v1/userbuilding`,
  GET_USER_PROFILE: id => `user-management/v1/userprofile/${id}`,
  GET_USER: ({ params }) => `user-management/v1/relation/users/${params}`,
  GET_BUILDING: ({ params }) => `user-management/v1/userbuilding/${params}`,
  SEARCH_USER: ({ params }) => `/user-management/v1/search/user/${params}`,
  ADD_ASSOCIATE: ({ params }) => `/user-management/v1/user/associate${params}`,
  DIS_ASSOCIATE: ({ params }) =>
    `/user-management/v1/user/disassociate${params}`,
  USER_VALIDATION: ({ params }) => `/user-management/v1/credvalidate${params}`,
  GET_BRAND: ({ id }) => `/user-management/v1/brand/${id}`,
  GET_ALL_BRAND: ({ params }) => `/user-management/v1/all/brand/${params}`,
  GET_IMAGE_FILE: ({ params }) => `/user-management/v1/file${params}`,
  DELETE_IMAGE_FILES: ({ params }) => `/user-management/v1/files${params}`,
  ADD_BRAND: ({ params }) => `user-management/v1/brand${params}`,
  SEARCH_BRAND: ({ params }) => `/user-management/v1/search/brand/${params}`,
  SEARCH_JOB_LIST: `/job-management/v1/search/job`,
  GET_ERROR_CODE: ({ pageNo, params }) =>
    `/job-management/v1/job/model/errorcode/${pageNo}${params}`,
  FISCAL_YEARS: `/job-management/v1/fiscalyear`,
  JOBS: '/job-management/v1/job',
  SCRATCH_TICKET_BOX: '/job-management/v1/box',
  SCRATCH_TICKET: '/job-management/v1/bookkeeping/scratchticket',
  SEARCH_SCRATCH_TICKET: '/job-management/v1/bookkeeping/scratchticket/search',
  SCRATCH_TICKET_BOOK: '/job-management/v1/scratchticket/book',
  TOTAL_VALUES: '/job-management/v1/total',
  TUBE: '/job-management/v1/tube',
  BOOK_KEEPING_TUBE: '/job-management/v1/bookkeeping/tube',
  SEARCH_TUBE: '/job-management/v1/bookkeeping/tube/search',
  MACHINES: '/job-management/v1/machines',
  MACHINE_TICKETS: '/job-management/v1/machinetickets',
  CASHBACK: '/job-management/v1/cashback',
  VENDOR_PAYOUT: '/job-management/v1/vendorpayout',
  INVENTORY: '/job-management/v1/inventory',
  SHIFT_REPORT: '/job-management/v1/shiftreport',
  TRIGGER_REPORT: '/job-management/v1/triggerreport',
  USER_REPORTS: '/job-management/v1/userreports',
  GET_EQUIPMENT: ({ params }) => `/user-management/v1/all/ein/${params}`,
  SEARCH_EQUIPMENT: ({ params }) => `/user-management/v1/search/ein/${params}`,
  GET_ADDRESS_DATA: ({ params }) =>
    `/dataviz-management/v1/statecitylist${params}`,
  GET_EQUIPMENT_DATA: ({ params }) =>
    `/dataviz-management/v1/brand/jobs/${params}`,
  GET_EQUIPMENT_PIE_CHART_DATA: ({ params }) =>
    `/dataviz-management/v1/piechart${params}`,
  GET_TOTAL_USER_DATA: ({ params }) =>
    `/dataviz-management/v1/user/job/total${params}`,
  GET_FE_USER_DATA: ({ params }) =>
    `/dataviz-management/v1/brand/user/jobs/${params}`,
  ADD_ERROR_CODE: `/user-management/v1/errorcode`,
  GET_FILTER_USER_DATA: ({ userType, pageNo }) =>
    `/dataviz-management/v1/filter/${userType}/${pageNo}`,
  GET_SEARCH_FILTER_DATA: ({ userType, pageNo, search }) =>
    `/dataviz-management/v1/filter/search/${userType}/${pageNo}?search=${search}`,
  GET_BUILDING_DETAILS: ({ buildingId }) =>
    `/dataviz-management/v1/building/${buildingId}`,
  GET_EQUIPMENT_DETAILS: ({ buildingId, equipmentId }) =>
    `/dataviz-management/v1/building/${buildingId}/equipment/${equipmentId}`,
  GET_REPORT: ({ jobId, jobType }) =>
    `/job-management/v1/report?jobId=${jobId}&jobType=${jobType}`,
  GET_BRAND_TOTAL: ({ params }) =>
    `/dataviz-management/v1/brand/jobs/total${params}`,
  SHARE_REPORT: `/job-management/v1/email-sms`,
  UPDATE_REPORT: `/job-management/v1/updation/report`,
  DASHBOARD_SHIFT_REPORT: '/dashboard-management/v1/shiftreport',

  GET_COLUMN_LIST: ({ params }) => `/job-management/v1/reportcolumn${params}`,
  SAVE_FLEXIBLE_REPORT: `/job-management/v1/userflexiblereport`,
  GET_SAVE_FLEXIBLE_REPORT: `/job-management/v1/userflexiblereport`,
  GET_SINGLE_REPORT: `/job-management/v1/userflexiblereport`,
  GET_FLEXIBLE_REPORT_CALCULATION: `/job-management/v1/flexible_report_calculation`,
  GET_GENERATED_REPORT: ({ params }) => `/job-management/v1/report${params}`,
  GET_STAFF_AVAILABILITY_CHART: `/dashboard-management/v1/staff-nurse-availability/pie-chart`,
  GET_STAFF_AVAILABILITY_HOSTELS: ({ pageNo }) =>
    `/dashboard-management/v1/staff-nurse-availability/hostels/${pageNo}`,
  GET_AWC_STAFF_DETAILS_BAR_CHART: `/dashboard-management/v1/awc-staff-details/bar-chart`,
  GET_AWC_STAFF_DETAILS_ANGANWADI_LIST: ({ pageNo }) =>
    `/dashboard-management/v1/awc-staff-details/anganwadi-list/${pageNo}`,
  GET_CHILDREN_ENROLLMENT_BAR_CHART: `/dashboard-management/v1/children-enrollment/bar-chart`,
  GET_CHILDREN_ENROLLMENT_ANGANWADI_LIST: ({ pageNo }) =>
    `/dashboard-management/v1/children-enrollment/anganwadi-list/${pageNo}`,
  GET_CHILD_FITNESS_BAR_CHART: `/dashboard-management/v1/child-fitness/bar-chart`,
  GET_CHILD_FITNESS_ANGANWADI_LIST: ({ pageNo }) =>
    `/dashboard-management/v1/child-fitness/anganwadi-list/${pageNo}`,
  GET_WOMEN_ENROLLMENT_BAR_CHART: `/dashboard-management/v1/women-enrollment/bar-chart`,
  GET_WOMEN_ENROLLMENT_ANGANWADI_LIST: ({ pageNo }) =>
    `/dashboard-management/v1/women-enrollment/anganwadi-list/${pageNo}`,
  GET_ANGANWADI_LOCATION_TYPE_BAR_CHART: `/dashboard-management/v1/anganwadi-location-type/bar-chart`,
  GET_ANGANWADI_LOCATION_TYPE_ANGANWADI_LIST: ({ pageNo }) =>
    `/dashboard-management/v1/anganwadi-location-type/anganwadi-list/${pageNo}`,
  GET_DRINKING_WATER_SOURCE_BAR_CHART: `/dashboard-management/v1/drinking-water-source/bar-chart`,
  GET_DRINKING_WATER_SOURCE_ANGANWADI_LIST: ({ pageNo }) =>
    `/dashboard-management/v1/drinking-water-source/anganwadi-list/${pageNo}`,
  GET_PHC_LOCATED_BAR_CHART: `/dashboard-management/v1/phc-located/bar-chart`,
  GET_PHC_LOCATED_ANGANWADI_LIST: ({ pageNo }) =>
    `/dashboard-management/v1/phc-located/anganwadi-list/${pageNo}`,
  GET_HEALTH_CHECKUPS_BAR_CHART: `/dashboard-management/v1/health-checkups/bar-chart`,
  GET_HEALTH_CHECKUPS_ANGANWADI_LIST: ({ pageNo }) =>
    `/dashboard-management/v1/health-checkups/anganwadi-list/${pageNo}`,
  GET_EDUCATION_BAR_CHART: `/dashboard-management/v1/education/bar-chart`,
  GET_EDUCATION_ANGANWADI_LIST: ({ pageNo }) =>
    `/dashboard-management/v1/education/anganwadi-list/${pageNo}`,
  GET_NUTRITION_KITCHEN_BAR_CHART: `/dashboard-management/v1/nutrition-kitchen/bar-chart`,
  GET_NUTRITION_KITCHEN_ANGANWADI_LIST: ({ pageNo }) =>
    `/dashboard-management/v1/nutrition-kitchen/anganwadi-list/${pageNo}`,
  GET_COMMUNITY_MEETINGS_BAR_CHART: `/dashboard-management/v1/community-meetings/bar-chart`,
  GET_COMMUNITY_MEETINGS_ANGANWADI_LIST: ({ pageNo }) =>
    `/dashboard-management/v1/community-meetings/anganwadi-list/${pageNo}`,
  GET_ROOMS_AVAILABLE_CHART: `/dashboard-management/v1/rooms-available-chart`,
  GET_ROOMS_AVAILABLE_CHART_ANGANWADI_LIST: ({ pageNo }) =>
    `/dashboard-management/v1/rooms-available-chart/anganwadi-list/${pageNo}`,
  GET_TOILETS_AVAILABLE_CHART: `/dashboard-management/v1/toilets-available-chart`,
  GET_TOILETS_AVAILABLE_CHART_ANGANWADI_LIST: ({ pageNo }) =>
    `/dashboard-management/v1/toilets-available-chart/anganwadi-list/${pageNo}`,
  GET_PREGNANT_WOMEN_ENROLLED_CHART: `/dashboard-management/v1/pregnant-women-enrolled-chart`,
  GET_PREGNANT_WOMEN_ENROLLED_CHART_ANGANWADI_LIST: ({ pageNo }) =>
    `/dashboard-management/v1/pregnant-women-enrolled-chart/anganwadi-list/${pageNo}`,
  GET_LACTATING_WOMEN_ENROLLED_CHART: `/dashboard-management/v1/lactating-women-enrolled-chart`,
  GET_LACTATING_WOMEN_ENROLLED_CHART_ANGANWADI_LIST: ({ pageNo }) =>
    `/dashboard-management/v1/lactating-women-enrolled-chart/anganwadi-list/${pageNo}`,
  GET_BASIC_AMENITIES_BAR_CHART: `/dashboard-management/v1/basic-amenities/bar-chart`,
  GET_BASIC_AMENITIES_ANGANWADI_LIST: ({ pageNo }) =>
    `/dashboard-management/v1/basic-amenities/anganwadi-list/${pageNo}`,
  GET_MEDICAL_CARE_DONUT_CHART: `/dashboard-management/v1/medical-care/donut-chart`,
  GET_MEDICAL_CARE_DONUT_CHART_ANGANWADI_LIST: ({ pageNo }) =>
    `/dashboard-management/v1/medical-care/donut-chart/anganwadi-list/${pageNo}`,
  CHART_REPORT: `/dashboard-management/v1/trigger-report`,
  GET_NOTIFICATIONS: ({ pageNo }) =>
    `/user-management/v1/notifications/${pageNo}`,
  TRIGGER_JOB_REPORT: `/job-management/v1/triggerreport`,
  DELETE_USER: `/user-management/v1/user`,
  GET_LOCATION_ADDRESS: `/job-management/v1/lat-long-address`,
  GENERATE_MASTER_SHEET: `/job-management/v1/userreports`,
  GET_TILES: ({ params }) => `/growth/v1/tiles${params}`,
  GET_GROWTH: ({ params }) => `/growth/v1/growth/${params}`,
  ADD_EDIT_GROWTH: '/growth/v1/growth',
  DASHBOARD_PHOTOS: ({ pageNo }) => `/dashboard-management/v1/photos/${pageNo}`,
}
export default API_ROUTES
